import { ConsoleLogger, QueryBus } from '@skylab-shared/core';
import { saveAs } from 'file-saver-es';
import { ExportResult } from '../common/export/export-query.result';
import { ExportQuery } from '../common/export/export.query-base';


export interface File {
    readonly file: Blob;
    readonly filename: string;
}

export class ReportExporterServiceBase {
    private readonly logger = new ConsoleLogger(this.constructor.name);

    public constructor(private readonly queryBus: QueryBus) { }

    public async exportAsync(query: ExportQuery<ExportResult>): Promise<void> {
        try {
            const { file, filename } = await this.queryBus.queryAsync(query);

            saveAs(file, filename);
        } catch (err) {
            this.logger.error(err);
        }
    }
}
